export default class ProductUpdatesAll
{
  constructor() {
    this.$el = document.querySelector('.js-product-updates-all')

    if (! this.$el) {
      return
    }

    this.$topicSelect = document.querySelector('.js-product-updates-all-topic-select2');

    this.$topicSelect2 = jQuery('.js-product-updates-all-topic-select2-default').select2();

    const select2 = jQuery(this.$topicSelect).select2({
      theme: 'okendo',
      closeOnSelect: false,
			placeholder: "All topics",
    });

    select2.on('change', this.filterByTopic.bind(this));

    this.$loadMoreButton = document.querySelector('.js-product-updates-load-more');

    this.totalPosts = document.querySelector('.js-product-updates-all').dataset.numberOfReleases;

    this.perPage = 10

    this.showedPosts = this.perPage

    this.topics = []

    this.$loadMoreButton.addEventListener('click', this.loadMore.bind(this));

    this.showPosts()

    this.openPermalink()
  }

  openPermalink() {
    const urlParams = new URLSearchParams(window.location.search);

    const topics = urlParams.get('topics');
    if (topics) {
      jQuery(this.$topicSelect).val(topics.split(',')).trigger('change');
    }
  }

  updatePermalink(topics) {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("topics", topics);
    history.replaceState(null, null, '?' + queryParams.toString());
  }

  filterByTopic(e) {
    this.topics = jQuery(this.$topicSelect).select2('data').map(t => t.id)

    this.updatePermalink(this.topics)

    this.showPosts()
  }

  loadMore() {
    this.showedPosts += this.perPage

    this.showPosts()
  }

  showPosts() {
    let postCount = 0;
    let totalPosts = 0;

    const posts = document.querySelectorAll('.js-product-updates-all-posts > div.js-post');

    document.querySelectorAll('.js-month').forEach(month => month.classList.add('hidden'))

    for (const post of posts) {
      const inPage = postCount < this.showedPosts

      const topics = JSON.parse(post.dataset.topics)
      const inTopic = this.topics.length === 0 || this.topics.some(item => topics.includes(item))

      const show = inPage && inTopic

      post.classList.toggle('hidden', ! show)

      if (show) {
        postCount++;
        document.querySelector(post.dataset.month).classList.remove('hidden')
      }

      if (inTopic) {
        totalPosts++;
      }
    }

    this.$loadMoreButton.classList.toggle('hidden', postCount >= totalPosts)
    document.querySelector('.js-product-updates-all-posts').classList.toggle('done', postCount >= totalPosts)
  }
}
